import RFFInputField from '../../components/form/RFFInputField';
import RFFRadio from '../../components/form/RFFRadio';
// import RFFSelectField from '../../components/form/RFFSelect';
import ApprovedSource from '../../config/approvedSource.json';
import Certifications from '../../config/qualityCertifications.json';
import BusinessClassifications from '../../config/businessClassifications.json';
import CastingProcess from '../../config/castingProcess.json';
import CoreProcess from '../../config/coreProcess.json';
import SecondaryOperations from '../../config/SecondaryOperations.json';
import FederalClassification from '../../config/federalClassifications.json';
import RFFMultiSelectField from '../../components/form/RFFMultiSelect/RFFSelect';

const rapidToolingOptions = {
  fdm: 'Fused Deposition Modeling (FDM)',
  lom: 'Laminated Object Manufacturing (LOM)',
  sls: 'Selective Laser Sintering (SLS)',
  sgc: 'Solid Ground Curing (SGC)',
  sla: 'Stereolithography (SLA)',
};

const createOptions = obj => {
  const objKeys = Object.keys(obj);

  const options = objKeys.map(key => ({ text: obj[key], value: key }));
  return options;
};

// export const SupplierProfileFieldsLeft = [
//   {
//     name: 'company',
//     label: 'Company Name',
//     component: RFFInputField,
//     disabled: true,
//   },

//   {
//     name: 'simulationCapability',
//     label: 'Simulation Capability',
//     component: RFFRadio,
//     options: [
//       {
//         text: 'Yes',
//         value: true,
//       },
//       {
//         text: 'No',
//         value: false,
//       },
//     ],
//   },
// ];

export const SupplierProfileFieldsLeft = [
  {
    name: 'company',
    label: 'Company Name',
    component: RFFInputField,
    disabled: true,
  },
  {
    name: 'bizClass',
    label: 'Business Classifications',
    component: RFFMultiSelectField,
    options: createOptions(BusinessClassifications),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'qualityCerts',
    label: 'Quality Certifications',
    component: RFFMultiSelectField,
    options: createOptions(Certifications),
    mode: 'multiple',
    lableInValue: true,
    defaultValue: [],
  },
];

export const SupplierProfileFieldsRight = [
  {
    name: 'cage',
    label: 'Cage Code',
    component: RFFInputField,
    labelCol: { md: 3 },

    disabled: true,
  },
  {
    name: 'lowVolume',
    label: 'Low Volume',
    component: RFFRadio,
    options: [
      {
        text: 'Yes',
        value: "true",
      },
      {
        text: 'No',
        value: "false",
      },
    ],
  },
  {
    name: 'simulationCapability',
    label: 'Simulation Capability',
    component: RFFRadio,
    options: [
      {
        text: 'Yes',
        value: "true",
      },
      {
        text: 'No',
        value: "false",
      },
    ],
  },
];

// export const ClassificationsAndCapsFieldsLeft = [

// ];

export const ClassificationsAndCapsFieldsLeft = [
  {
    name: 'rapidTooling',
    label: 'Rapid Tooling',
    component: RFFMultiSelectField,
    options: createOptions(rapidToolingOptions),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'approvedSource',
    label: 'Approved Source',
    component: RFFMultiSelectField,
    options: createOptions(ApprovedSource),
    defaultValue: [],
    mode: 'multiple',
  },
  {
    name: 'coreProcesses',
    label: 'Core Process',
    component: RFFMultiSelectField,
    options: createOptions(CoreProcess),
    defaultValue: [],
    mode: 'multiple',
  },
];

export const ClassificationsAndCapsFieldsRight = [
  {
    name: 'fsc',
    label: 'Federal Classification',
    component: RFFMultiSelectField,
    mode: 'multiple',
    defaultValue: [],
    key: 'fsc',
    options: createOptions(FederalClassification),
  },
  {
    name: 'secondaryOperations',
    label: 'Secondary Operations',
    component: RFFMultiSelectField,
    options: createOptions(SecondaryOperations),
    mode: 'multiple',
  },
  {
    name: 'castings',
    label: 'Casting Process',
    component: RFFMultiSelectField,
    options: createOptions(CastingProcess),
    defaultValue: [],
    mode: 'multiple',
  },
  // {
  //   name: 'material',
  //   label: 'Materials',
  //   component: RFFCheckbox,
  //   options: createOptions(Materials),
  // },
];



// WEBPACK FOOTER //
// ./src/components/EditSupplierCaps/formConfig.jsx